import {
  commonGetters,
  commonMutations,
  commonActions
} from '@/store/store_utils'
import { getAxiosObject } from '@/utils/library'
import { toStateName } from '@/utils/convert_string'

const apiUrl = '/examination-pdf-files'
const dataName = 'examinationPdfFiles'
const indexKeys = ['patientId']

const state = {
  [dataName]: [],
  dataIndexedById: {},
  updatedAt: '20101010101010'
}
indexKeys.forEach(key => {
  state[toStateName(key)] = null
})

const getters = {
  ...commonGetters(dataName, ['getDataById', 'getUpdatedAt'], {
    getDataBy: indexKeys
  })
}

const actions = {
  ...commonActions(['setUpdatedAt', 'updateAfter']),
  async create({ commit }, { examinationPdfFile }) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.post(apiUrl, { examinationPdfFile })
      if (res.status === 200) {
        commit('updateAfter', [res.data.examinationPdfFile])
        return {
          status: 'success',
          examinationPdfFileId: res.data.examinationPdfFile.id
        }
      }
    } catch (error) {
      if (error.response?.data?.message) {
        return error.response.data.message === 'no data'
          ? `no ${error.response.data.extra}`
          : error.response.data.message
      } else {
        return 'server error'
      }
    }
  },
  async delete({ commit }, id) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.delete(apiUrl, { data: { id } })
      if (res.status === 200) {
        commit('updateAfter', [res.data.examinationPdfFile])
        return 'success'
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.extra?.data) {
          commit('setData', error.response.data.extra.data)
        }
        return error.response.data.message
      } else {
        return 'server error'
      }
    }
  },
  async update({ commit }, { examinationPdfFile }) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put(apiUrl, { examinationPdfFile })
      if (res.status === 200) {
        commit('updateAfter', [res.data.examinationPdfFile])
        return {
          status: 'success',
          examinationPdfFileId: res.data.examinationPdfFile.id
        }
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.message === 'no data in clinic') {
          commit('setData', error.response.data.extra.data)
          return 'no data in clinic'
        } else if (error.response.data.message === 'no data') {
          return `no ${error.response.data.extra}`
        } else if (error.response?.data?.extra) {
          return error.response.data.extra
        } else {
          return error.response.data.message
        }
      } else {
        return 'server error'
      }
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setUpdatedAt', 'updateAfter'], {
    indexedById: true,
    setDataBy: indexKeys
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
